<template>
  <div class="row boxes-row">
    <template v-if="quizzes.length">
      <div class="col-lg-4" v-for="box in quizzes" :key="box.idQuiz">
        <QuizBox :box="box"></QuizBox>
      </div>
    </template>
    <template v-else>
      <div class="col-lg-12">
        <div class="row" style="justify-content: center;">
          <div style="display:flex; justify-content: center; flex-direction: column;">
            <img src="../../assets/images/coming-soon-1.svg">
            <div>No ongoing quizzes.</div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import QuizBox from "@/components/quiz/QuizBox";
export default {
  name: "QuizList",
  components: {QuizBox},
  computed: {
    company() {
      return this.$store.getters.company
    },
    quizzes() {
      return this.$store.getters.quizzes
    }
  },
  mounted() {
    window._paq.push(['setDocumentTitle', 'Quiz List']);
    window._paq.push(['trackPageView']);
  }
}
</script>
